module.exports = __webpack_public_path__ + "files/5ae77a33c74f6845f5c5061e4402dffe.png";